import moment from "moment";
import reduxStore from "../configureEnvStore";
import { APIs } from "../constants/APIConstants";
import { ENABLED } from "../constants/Constants";
import { LogFirebase } from "./firestore";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import navigatorService from "./navigatorService";
import watermarkImageService from "./WatermarkImage/watermarkImageService";
import api from "../apis/api";
import CustomToast from "../components/UI/customToast";
import { isLocalUserStreaming } from "../components/Twilio/Room/roomFunction";
import Localize from "../locale/Localize";
import { NOTIFICATION_TYPES } from "../constants/DataTrackNotificationConstants";
import { empty, totalTimeInSeconds } from "../shared/utility";
import { addContainerImageInArray } from "../reducers/imageContainer-reducer";
import extractTextService from "./extractTextService";
import { addEditCustomToastInstanceArray, removeCustomToastInstanceArray } from "../reducers/extractText-reducer";
import { sendDataTrack } from "../shared/dataTrackFunction";
import { getRoom } from "../components/Twilio/Room/roomService";
import { getTracksByType } from "../components/Twilio/twilioCallUtility";

class TakePhotoService {
    constructor() {
        this.takePhotoresetState();
    }
    takePhotoresetState() {
        this.agentStreamOnTakePhoto = 0;
        this.imageDataList = [];
        this.uploadListLength = 0;
        this.prevPhotoStatus = 0;
        this.photoIndex = 0;
        this.uploadPhotoCount = 0;
        this.uploading = 0;
        this.uploaded = 0;
        this.isUploading = false;
        this.uploadedImage = {
            bookmarkId: "",
            usedBookmarkcount: "",
            imgThumb: "",
            imgOrigin: "",
            imgFileName: "",
        };
        this.threeTimeCallIfError = 0;
        this.status = {
            uploadImageFail: "0",
            uploadImageInproress: "1",
            uploadImageSuccess: "2",
            showCapturing: "3",
        };
        this.inerror = false;
    }

    changeToCapturing() {
        //change text to 'capturing..' for 2 seconds
        const takePhotobutton = document.getElementById("take-photo-button");
        const buttonText = takePhotobutton.querySelector(".for-text");
        takePhotobutton.disabled = true;
        buttonText.textContent = Localize[PublicVariables.currentLanguageObj.languageCode]["capturing"];
        setTimeout(() => {
            takePhotobutton.disabled = false;
            buttonText.textContent = Localize[PublicVariables.currentLanguageObj.languageCode]["take_photo"];
        }, 2000);
    }

    takePhotoRequestToStreamingUser(msg) {
        console.log("message", msg);
        LogFirebase("TakePhoto", "received_msg", "Take photo notification received");
        // notification for take photo from local stream.
        if (msg.identity !== CALL_DATA.localIdentity) {
            if (isLocalUserStreaming()) {
                let bookmark = null;
                if (!empty(msg.bookmark)) {
                    bookmark = { bookmarkId: msg.bid, bookmarkName: msg.bookmark };
                }
                this.takePhotoForStreamingUser(bookmark);
            }
        }
    }

    handleTakePhotoRequestFromStreamingUser(msg) {
        console.log("message", msg);
        LogFirebase("TakePhoto", "received_msg_status", msg.status);
        if (msg.status == this.status.showCapturing) {
            //acknowledge to change capturing text in the take photo button
            this.changeToCapturing();
        }
        if (GLOBAL_MEETING_DATA.isAgent) {
            this.manageTakePhotoStatus(msg);
        }
    }

    sendTakePhotoAck = (uploadStatus, uploadingCount, thumbUrl, bookmark, image_url, imageName) => {
        //Send ACK to Agent
        let takePhotoMessagePayload = {
            notification_type: NOTIFICATION_TYPES.TAKE_PHOTO.STREAMING_USER_TO_ALL,
            identity: CALL_DATA.localIdentity,
            status: uploadStatus.toString(),
            total_photos: this.uploadListLength,
            uploading: uploadingCount,
            prevUploadStatus: this.prevPhotoStatus,
            device_type: GLOBAL_MEETING_DATA.device_type,
            image_url: image_url,
        };
        if (uploadStatus == 1 || uploadStatus == 2) {
            takePhotoMessagePayload.thumbURL = encodeURI(thumbUrl);
        }
        if (imageName) {
            takePhotoMessagePayload.imageName = imageName;
        }
        if (!empty(bookmark)) {
            takePhotoMessagePayload.bid = bookmark.bookmarkId;
            takePhotoMessagePayload.usedCount = bookmark.USEDCOUNT;
        }

        console.log(takePhotoMessagePayload);
        sendDataTrack(takePhotoMessagePayload);
        LogFirebase("TakePhoto", "send_msg_image_uploading_status", "uploading:" + uploadingCount + "::total:" + this.uploadListLength);
    };

    addThumbInList(thumbURL, fileUrl, imageName, caption = "", uploadType = false) {
        console.log("in add thumb list=---------------");
        console.log(fileUrl);
        let decodedUrl = decodeURI(thumbURL);
        let locationImage = false;
        if (imageName && imageName.indexOf("location") > -1) {
            locationImage = true;
        }
        let imgObj = {
            thumb: decodedUrl,
            original: fileUrl,
            name: imageName,
            isLocationImage: locationImage,
            caption: caption,
            uploadType: uploadType,
        };
        reduxStore.dispatch(addContainerImageInArray(imgObj));
    }

    handleUploadInProgressStatus(msg) {
        // Prepare guest view for agent
        if (!msg.isLocationImage) {
            this.showUploadingStatus(
                Localize[PublicVariables.currentLanguageObj.languageCode]["uploading_image"] +
                    " " +
                    "(" +
                    msg.uploading +
                    "/" +
                    msg.total_photos +
                    ")"
            );
        }
        if (msg.prevUploadStatus && !empty(msg.prevUploadStatus) && msg.prevUploadStatus == 1) {
            if (msg.thumbURL) {
                this.addThumbInList(msg.thumbURL, msg.image_url, msg.imageName);
            }
        }
    }

    handleUploadSuccessStatus(msg) {
        //acknowledge to agent for photo upload status in image container
        if (GLOBAL_MEETING_DATA.isGuest) {
            this.dismissToastObj();
        }
        if (msg.prevUploadStatus && !empty(msg.prevUploadStatus) && msg.prevUploadStatus == 1) {
            if (msg.thumbURL) {
                this.addThumbInList(msg.thumbURL, msg.image_url, msg.imageName);
                if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                    LogFirebase("TakePhoto", "received_msg_added_thumb", msg.thumbURL);
                } else {
                    LogFirebase("TakePhoto", "received_msg_added_thumb", "");
                }
            }
        } else {
            LogFirebase("TakePhoto", "received_msg_status_2", "photos_not_added_in_thumb");
        }
        //// if(bookmarkService.isBidSet(msg.bid)){
        ////     bookmarkService.showBookmarkSavedWithImage();
        ////    LogFirebase("Bookmarks","saved_bookmark_with_image", "UPLOADED::"+msg.thumbURL);
        //// }else
        if (!msg.isLocationImage) {
            this.showUploadingStatus(Localize[PublicVariables.currentLanguageObj.languageCode]["upload_completed"], true);
            LogFirebase("TakePhoto", "received_msg_status_2", "Upload completed::" + msg.thumbURL);
        }
    }

    handleUploadFailStatus() {
        // Change user's upload status to blank in call participants array
        if (GLOBAL_MEETING_DATA.isGuest) {
            this.dismissToastObj();
        }
        LogFirebase("TakePhoto", "received_msg_status_0", "upload failed");
        this.dismissToastObj();
        if (this.uploading > 0 && this.imageDataList.length == 0) {
            this.uploading = 0;
            this.uploaded = 0;
        }
        CustomToast.error(Localize[PublicVariables.currentLanguageObj.languageCode]["upload_failed"]);
    }

    handleDefaultStatus(msg) {
        LogFirebase("TakePhoto", "received_msg_status", msg.status);
    }

    manageTakePhotoStatus(msg) {
        switch (msg.status.toString()) {
            case this.status.uploadImageInproress:
                this.handleUploadInProgressStatus(msg);
                break;
            case this.status.uploadImageSuccess:
                this.handleUploadSuccessStatus(msg);
                break;
            case this.status.uploadImageFail:
                this.handleUploadFailStatus();
                break;
            default:
                this.handleDefaultStatus(msg);
        }
        //check if bookmark count needs to be updated from guest
        if (msg.status == this.status.uploadImageSuccess || msg.status == this.status.uploadImageInproress) {
            reduxStore.dispatch({ event: "BOOKMARK_WITH_IMAGE", type: "", payload: msg });
            //// if(bookmarkService.isBidSet(msg.bid)){
            ////     bookmarkService.updateBookmarkCount(msg.bid,msg.usedCount);
            //// }
        }
    }

    takePhoto = (bookmark) => {
        LogFirebase("TakePhoto", "take_photo_clicked", " clicked by=" + CALL_DATA.localIdentity);
        if (isLocalUserStreaming()) {
            this.takePhotoForStreamingUser(bookmark);
        } else {
            console.log("in remote participant video!");
            this.changeToCapturing();
            let msg = {
                notification_type: NOTIFICATION_TYPES.TAKE_PHOTO.TO_STREAMING_USER,
                identity: CALL_DATA.localIdentity,
            };
            if (!empty(bookmark)) {
                msg.bid = bookmark?.bookmarkId.toString();
                msg.bookmark = bookmark?.bookmarkName;
            }
            sendDataTrack(msg);
            LogFirebase("TakePhoto", "send_msg", "Sending take phto notification");
        }
    };

    takePhotoForStreamingUser(bookmark) {
        if (!empty(bookmark)) {
            LogFirebase("TakePhoto", "take_photo_from_bookmark", bookmark.BNAME);
        }
        const { isLocalUserScreenSharing, startLocalVideo } = reduxStore.getState().twilioEvents;
        if (GLOBAL_MEETING_DATA.isAgent && (startLocalVideo || isLocalUserScreenSharing)) {
            /*flag requies because when photo taken agent stream was on and by the 
            time upload success response comes if guest overrides or agent stops video, incremented
            count wont be shown */
            this.agentStreamOnTakePhoto = 1;
        }
        // send msg to agent to change button text and disable for 2 seconds
        if (GLOBAL_MEETING_DATA.isGuest) {
            this.sendTakePhotoAck(this.status.showCapturing, 0);
        }
        this.changeToCapturing();
        let width, height, video;
        let dateTime = +new Date().getTime();
        let timestamp = Math.floor(dateTime / 10); // to fix all image to be uploaded
        LogFirebase("TakePhoto", "savingPhoto", {
            ["started_uploading_photo"]: "name_" + timestamp,
            localPartiIdentity: CALL_DATA.localIdentity,
        });
        video = document.querySelector("#expandedVideo video");

        if (video != undefined && video != null && video != "" && video.videoWidth != 0 && video.videoHeight != 0) {
            width = video.videoWidth;
            height = video.videoHeight;
            if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                LogFirebase("TakePhoto", "videoConstraints", { height: height, width: width });
            }

            console.log("height " + height + "width  " + width);
        } else {
            LogFirebase("TakePhoto", "video_element_not_found", "");
        }

        this.imageCaptureForTakePhotoMarkupOCRCanvas("TakePhoto", video, width, height, bookmark);
    }

    handleNormalCapture(fromWhere, video, width, height, bookmark) {
        /* if user is not in chrome browser or imageCapture API not supported for the browser then in this condition func will call (ex. iOS safari, chrome)*/
        LogFirebase(fromWhere, "normal_capture", "in_else");
        this.commonFunctionTohandleUploadImage(video, width, height, false, fromWhere, bookmark, false);
    }

    performImageCapture(imageCapture, fromWhere, video, width, height, bookmark) {
        let counter = 0;
        let intervalForImageCaptureError = setInterval(() => {
            counter++; // in this interval we try 3 times to check imageCapture track condition fulfill
            console.log("counter value: ", counter);
            if (!(imageCapture.track.readyState != "live" || !imageCapture.track.enabled || imageCapture.track.muted)) {
                // this check for error handling (error: The associated Track is in an invalid state)
                imageCapture
                    .grabFrame()
                    .then((imageBitmap) => {
                        if (imageBitmap) {
                            LogFirebase(fromWhere, "imageCapture_grabFrame", "in_sucess");
                            clearInterval(intervalForImageCaptureError);
                            this.commonFunctionTohandleUploadImage(video, width, height, imageBitmap, fromWhere, bookmark);
                        }
                    })
                    .catch((error) => {
                        console.log("in catch clear interval: ", error);
                        clearInterval(intervalForImageCaptureError);
                        LogFirebase(fromWhere, "imageCapture_grabFrame", "in_catch");
                        // this func call for, incase if we failed to imageCapture.grabFrame then normal flow image we upload
                        this.commonFunctionTohandleUploadImage(video, width, height, false, fromWhere, bookmark);
                    });
            } else {
                LogFirebase(fromWhere, "imageCapture_grabFrame_in_else", {
                    counter: counter,
                    track_readyState: imageCapture.track.readyState,
                    track_enabled: imageCapture.track.enabled,
                    track_muted: imageCapture.track.muted,
                });
                clearInterval(intervalForImageCaptureError);
                if (counter == 3) {
                    console.log("maximum imageCapture try reached: ");
                    LogFirebase("OCR", "imageCapture_grabFrame", "maximum_imageCapture_reached");
                    // this func call for, incase if we failed to imageCapture.grabFrame then normal flow image we upload
                    this.commonFunctionTohandleUploadImage(video, width, height, false, fromWhere, bookmark);
                }
            }
        }, 2000);
    }

    /* common function for create markup and EXtract text canvas using imageCapture API */
    imageCaptureForTakePhotoMarkupOCRCanvas(fromWhere, video, width, height, bookmark) {
        let imageCapture;
        const room = getRoom();
        const localVideoTracks = getTracksByType(room.localParticipant, "video");

        console.log(localVideoTracks);

        if (navigatorService.isImageCaptureSupported(localVideoTracks)) {
            /*
                - if user in chrome browser and imageCapture API is supported for the browser
                then in this condition func will call (ex. windows chrome, edge)
                - this solution for, while screen share visibility issue blank canvas is created for guest user
                - this solition for video and screen share both
            */
            const objStream = new MediaStream();
            objStream.addTrack(localVideoTracks[0].mediaStreamTrack);
            const [track] = objStream.getVideoTracks();
            imageCapture = new ImageCapture(track);
            this.performImageCapture(imageCapture, fromWhere, video, width, height, bookmark);
        } else {
            this.handleNormalCapture(fromWhere, video, width, height, bookmark);
        }
    }

    commonFunctionTohandleUploadImage = (video, width, height, imageBitmap, fromWhere, bookmark) => {
        if (fromWhere == "TakePhoto") {
            this.processTakePhoto(video, width, height, imageBitmap, bookmark);
        } else {
            extractTextService.uploadImageForMarkupOCR(video, width, height, imageBitmap, fromWhere);
        }
    };

    processTakePhoto(video, width, height, imageBitmap, bookmark) {
        console.log("in process take photo function");
        let img = new Image();

        let objVal = watermarkImageService.__watermarkImage.fetchImageWaterMark({
            screenType: "image",
            width: width,
            height: height,
            localOrientation: navigatorService.getOrientation(),
            bookmark: bookmark,
            liveLat: false,
            liveLong: false,
        });

        const { imageSrc, canvasHeight } = objVal;
        img.src = imageSrc;
        let canvas = document.getElementById("screenshotcanvas");
        let context = canvas.getContext("2d");
        if (width && height) {
            canvas.width = width;
            canvas.height = canvasHeight;
            console.log("height " + canvas.height + "width  " + canvas.width);

            //take video view on canvas
            if (imageBitmap) {
                context.drawImage(imageBitmap, 0, 0, imageBitmap.width, imageBitmap.height);
            } else {
                context.drawImage(video, 0, 0, width, height);
            }

            const tempVideoImage = context.getImageData(0, 0, width, height);
            img.onload = () => {
                context.drawImage(img, 0, 0);
                this.processUploadPhoto(canvas, bookmark);
            };
            img.onerror = () => {
                //if watermark image fails, upload without watermark
                LogFirebase("TakePhoto", "watermark_img_failed", "");
                canvas.width = width;
                canvas.height = height;
                context.putImageData(tempVideoImage, 0, 0);
                this.processUploadPhoto(canvas, bookmark);
            };
        }
    }

    showUploadingStatus(message, isSuccess) {
        reduxStore.dispatch(addEditCustomToastInstanceArray({ id: 1, message: message, isLoading: !isSuccess, showCloseIcon: false }));
        if (isSuccess) {
            setTimeout(() => {
                this.dismissToastObj();
            }, 2000);
        }
    }

    dismissToastObj = () => {
        reduxStore.dispatch(removeCustomToastInstanceArray(1));
    };

    processUploadPhoto(canvas, bookmark) {
        const videoElement = document.querySelector("#expandedVideo video");
        if (videoElement) {
            videoElement.classList.add("take-photo-effect");
            setTimeout(() => {
                videoElement.classList.remove("take-photo-effect");
            }, 500);
        }

        let liveimgdata = canvas.toDataURL("image/jpeg");
        let imageData = liveimgdata;
        let objImg = { imgData: imageData, bookmark: bookmark };
        this.imageDataList.push(objImg);
        this.uploadListLength = this.imageDataList.length;

        //to update total photos in the toast
        if (this.isUploading) {
            if (this.uploading > this.imageDataList.length) {
                LogFirebase("TakePhoto", "count_mismatch_uploading_count_processUploadPhoto", {
                    uploading: this.uploading,
                    imageDataListLength: this.imageDataList.length,
                });
                this.uploading = this.imageDataList.length;
            }
            this.showUploadingStatus(
                Localize[PublicVariables.currentLanguageObj.languageCode]["uploading_image"] +
                    " (" +
                    this.uploading +
                    "/" +
                    this.imageDataList.length +
                    ")"
            );
        }

        console.log("::image array length=" + this.uploadListLength);
        console.log(this.imageDataList);

        if (this.imageDataList.length == 1) {
            console.log("call first time");
            this.uploadPhoto(this.imageDataList[0], (result) => {
                LogFirebase("TakePhoto", "in_uploadPhoto_result", result);
                this.photoIndex = 0;
                this.imageDataList = [];
                this.uploadListLength = 0;
                this.prevPhotoStatus = 0;
            });
        }
    }

    initializeUploadStatus() {
        this.isUploading = true;
        this.uploading++;
        if (this.uploading > this.imageDataList.length) {
            LogFirebase("TakePhoto", "count_mismatch_uploading_count_initializeUploadStatus", {
                uploading: this.uploading,
                imageDataListLength: this.imageDataList.length,
            });
            this.uploading = this.imageDataList.length;
        }
        this.showUploadingStatus(
            Localize[PublicVariables.currentLanguageObj.languageCode]["uploading_image"] +
                " (" +
                this.uploading +
                "/" +
                this.imageDataList.length +
                ")"
        );
    }

    sendUploadStatus() {
        if (!GLOBAL_MEETING_DATA.isAgent) {
            this.sendTakePhotoAck(
                this.status.uploadImageInproress,
                this.uploaded + 1,
                this.uploadedImage.imgThumb,
                { BID: this.uploadedImage.bookmarkId, USEDCOUNT: this.uploadedImage.usedBookmarkcount },
                this.uploadedImage.imgOrigin,
                this.uploadedImage.imgFileName
            );
        }
    }

    handleUploadedPhotoInfo(result) {
        this.photoIndex++;
        if (!empty(result.bid) && result.bid !== "0") {
            this.uploadedImage.bookmarkId = result.bid;
            this.uploadedImage.usedBookmarkcount = result.usedcount;
        }
        if (this.uploaded > this.imageDataList.length) {
            LogFirebase("TakePhoto", "count_mismatch_uploaded_count", {
                uploaded: this.uploaded,
                imageDataListLength: this.imageDataList.length,
            });
            this.uploaded = this.imageDataList.length;
        }
        this.showUploadingStatus(
            Localize[PublicVariables.currentLanguageObj.languageCode]["uploading_image"] +
                " (" +
                this.uploaded +
                "/" +
                this.imageDataList.length +
                ")"
        );
        this.prevPhotoStatus = 1;
        this.uploadedImage.imgThumb = result.thumbUrl;
        this.uploadedImage.imgOrigin = result.fileUrl;
        this.uploadedImage.imgFileName = result.fileName;
        if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
            LogFirebase("TakePhoto", "image_uploading_status", "UPLOADED::" + this.uploadedImage.imgThumb);
        } else {
            LogFirebase("TakePhoto", "image_uploading_status", "UPLOADED");
        }
        //if agent is streaming- NO 501 ack msg - so just increase total upload count
        if (GLOBAL_MEETING_DATA.isAgent && this.agentStreamOnTakePhoto) {
            if (!empty(result.bid) && result.bid !== "0") {
                //update bookmark count
                reduxStore.dispatch({ event: "BOOKMARK_WITH_IMAGE", type: "", payload: result });
                //// bookmarkService.updateBookmarkCount(this.uploadedImage.bookmarkId,this.uploadedImage.usedBookmarkcount);
            }
            this.addThumbInList(result.thumbUrl, result.fileUrl, result.fileName);
        }
    }

    handleUploadPhotoCompleted(imageData, result) {
        //send acknowledge to agent for photo upload status
        if (!GLOBAL_MEETING_DATA.isAgent) {
            if (!empty(imageData.bookmark)) {
                imageData.bookmark.USEDCOUNT = this.uploadedImage.usedBookmarkcount;
            }
            this.sendTakePhotoAck(
                this.status.uploadImageSuccess,
                this.uploading,
                this.uploadedImage.imgThumb,
                imageData.bookmark,
                result.fileUrl,
                result.fileName
            );
            LogFirebase("TakePhoto", "sendSavePhotoAck", {
                status: "2",
                thumb: this.uploadedImage.imgThumb,
            });
        } else {
            this.agentStreamOnTakePhoto = 0;
        }
        this.uploading = 0;
        this.uploaded = 0;
        this.imageDataList = [];
        if (!empty(imageData.bookmark) && GLOBAL_MEETING_DATA.isAgent) {
            //// bookmarkService.showBookmarkSavedWithImage();
            LogFirebase("Bookmarks", "saved_bookmark_with_image", "UPLOADED::" + this.uploadedImage.imgThumb);
            this.isUploading = false;
            this.dismissToastObj();
        } else {
            LogFirebase("TakePhoto", "saved_image", "UPLOADED::" + this.uploadedImage.imgThumb);
            this.showUploadingStatus(Localize[PublicVariables.currentLanguageObj.languageCode]["successfully_uploaded"], true);
        }
        setTimeout(() => {
            this.dismissToastObj();
            this.isUploading = false;
        }, 2000);
    }

    handleUploadPhotofailed(imageData, result, callbackToProcessUploadPhoto) {
        LogFirebase("TakePhoto", "image_uploading_status", "FAILED");
        LogFirebase("TakePhoto", "imgUploadError", {
            imgName: this.getFileName(
                "image",
                this.uploadPhotoCount,
                "jpeg",
                imageData?.bookmark,
                PublicVariables.featureFlag?.FILENAMEFORMAT,
                PublicVariables.featureFlag?.ENABLEFOLDERNAMING
            ),
            error: result?.error?.toString(),
            isMapImage: false,
            status: "fail",
        });
        this.isUploading = false;
        this.uploading = this.uploading - 1;
        this.dismissToastObj();
        //send acknowledge to agent for photo upload status
        this.prevPhotoStatus = 0;
        if (result?.errorcode?.toString() == "-222" && this.threeTimeCallIfError < 4) {
            this.inerror = true;
            this.threeTimeCallIfError++;
            this.uploadPhoto(this.imageDataList[this.photoIndex], (_resultInner) => {
                callbackToProcessUploadPhoto(true);
            });
        } else {
            this.photoIndex++;
            if (!GLOBAL_MEETING_DATA.isAgent) {
                this.sendTakePhotoAck(this.status.uploadImageFail, this.uploading);
                LogFirebase("TakePhoto", "sendSavePhotoAck", "status: 0");
            }
            CustomToast.error(Localize[PublicVariables.currentLanguageObj.languageCode]["upload_failed"]);
        }
    }

    handleUploadPhotoInError(imageData, callbackToProcessUploadPhoto) {
        if (this.photoIndex < this.imageDataList.length) {
            console.log(this.photoIndex);
            console.log(this.imageDataList.length);
            LogFirebase("TakePhoto", "recursive_call_photo_upload", "");
            this.uploadPhoto(this.imageDataList[this.photoIndex], (_resultInner) => {
                LogFirebase("TakePhoto", "recursive_call_photo_upload", "in response");
                callbackToProcessUploadPhoto(true);
            });
        } else {
            //for local user
            if (this.imageDataList.length > 1) {
                this.isUploading = false;
                this.dismissToastObj();
                if (!empty(imageData.bookmark)) {
                    //// bookmarkService.showBookmarkSavedWithImage();
                } else {
                    this.showUploadingStatus(Localize[PublicVariables.currentLanguageObj.languageCode]["upload_completed"], true);
                    LogFirebase("TakePhoto", "show_upload_toast", "upload completed");
                }
            }
            callbackToProcessUploadPhoto(true);
        }
    }

    uploadPhoto(imageData, callbackToProcessUploadPhoto) {
        console.log("in upload photo function");
        LogFirebase("TakePhoto", "in_uploadPhoto_function", "");

        this.initializeUploadStatus();

        this.sendUploadStatus();

        let blob = watermarkImageService.__base64ToBlobImage.convertData(imageData?.imgData);
        //send request to backend with form data

        this.uploadImage("image", blob, imageData?.bookmark, (response) => {
            console.log("upload Image response", response);
            this.inerror = false;
            this.uploadedImage.bookmarkId = "";
            this.uploadedImage.usedBookmarkcount = "";
            this.uploadedImage.imgThumb = "";
            this.uploadedImage.imgOrigin = "";
            this.uploadedImage.imgFileName = "";
            let result = response.data;
            LogFirebase("TakePhoto", "in_uploadImage_response", "");

            if (response.success > 0) {
                this.uploaded = parseInt(this.uploaded) + 1;
                this.handleUploadedPhotoInfo(result);
                if (this.uploaded == this.imageDataList.length) {
                    this.handleUploadPhotoCompleted(imageData, result);
                } else {
                    LogFirebase("TakePhoto", "uploaded_count_not_equal_to_image_data_list", "");
                }
            } else {
                this.handleUploadPhotofailed(imageData, result, callbackToProcessUploadPhoto);
            }
            //recursive call for sequencial photo upload
            if (!this.inerror) {
                this.handleUploadPhotoInError(imageData, callbackToProcessUploadPhoto);
            }
        });
    }

    /**sends image to backend to upload at configured storage*/
    prepareFormData(imageFor, blob, fileName, bookmark) {
        //create file from blob
        const fileObj = new File([blob], fileName, { type: "image/jpeg" });
        console.log("::canfile", fileObj);
        const formData = new FormData();
        formData.append("file", fileObj);
        formData.append(
            "folderName",
            PublicVariables.featureFlag?.FOLDERNAMEFORMAT && PublicVariables.featureFlag?.ENABLEFOLDERNAMING === ENABLED
                ? PublicVariables.featureFlag.FOLDERNAMEFORMAT
                : ""
        );
        formData.append("fileName", fileName);
        formData.append("sessionId", GLOBAL_MEETING_DATA.sessionId);
        if (imageFor.indexOf("temp") <= -1) {
            LogFirebase("TakePhoto", "in_uploadImage_function", "fileName: " + fileName);
        }
        if (PublicVariables.featureFlag?.WATERMARKONPHOTOS === ENABLED) {
            if (CALL_DATA.Latitude !== 0) formData.append("latitude", CALL_DATA.Latitude);
            if (CALL_DATA.Longitude !== 0) formData.append("longitude", CALL_DATA.Longitude);
        }
        formData.append("fileType", "img");

        const { callDuration } = reduxStore.getState().commonReducer;
        //if bookmark available then send data into api
        if (!empty(bookmark)) {
            //For backend save bookmark working
            formData.append("Bookmark.Bid", bookmark.bookmarkId);
            formData.append("Bookmark.CallTime", totalTimeInSeconds(callDuration));
            formData.append("Bookmark.SessionId", GLOBAL_MEETING_DATA.sessionId);
            formData.append("Bookmark.MemberId", CALL_DATA.memberId);
            formData.append("Bookmark.RoomSid", CALL_DATA.roomSID);
        }

        return formData;
    }

    sendUploadImageRequest(uploadFileUrl, formData, imageFor, callbackForUploadImage) {
        api.sendImageRequest(uploadFileUrl, formData, {})
            .then((result) => {
                console.log("upload image response");
                if (imageFor !== "tempAnnotation") {
                    LogFirebase(formData === "OfflineMode" ? "OfflineMode" : "TakePhoto", "upload_image_in_response", "");
                }
                console.log(result);
                callbackForUploadImage(result);
            })
            .catch((err) => {
                console.log(err);
                if (imageFor !== "tempAnnotation") {
                    LogFirebase(formData === "OfflineMode" ? "OfflineMode" : "TakePhoto", "upload_image_in_response_catch", err);
                }
                callbackForUploadImage(err);
            });
    }

    uploadImage(imageFor, blob, bookmark, callbackForUploadImage) {
        if (!imageFor.includes("temp")) {
            // Increment photo count if not a temporary image
            this.uploadPhotoCount++;
        }

        const fileName = this.getFileName(imageFor, this.uploadPhotoCount, "jpeg");
        console.log("::fileName=" + fileName);

        const formData = this.prepareFormData(imageFor, blob, fileName, bookmark);
        const uploadFileUrl = imageFor === "tempAnnotation" ? APIs.UPLOAD_TEMP_FILE : APIs.UPLOAD_SESSION_FILE;
        this.sendUploadImageRequest(uploadFileUrl, formData, imageFor, callbackForUploadImage);
    }

    getFileName(type, totalPhotos, extension) {
        const cleanAgentName = (GLOBAL_MEETING_DATA.blitzzUserName || "agent").replace(/\s+/g, "_").replace(/[^\u4e00-\u9fa5a-zA-Z0-9_-]/g, "");
        let reference = "";
        let fileName = "";
        if (!empty(CALL_DATA.referenceId)) {
            reference = CALL_DATA.referenceId.replace(/\s+/g, "_");
            // for support chinese language add regex "\u4e00-\u9fa5"
            reference = reference.replace(/[^\u4e00-\u9fa5a-zA-Z0-9_-]/g, "");
        }
        if (reference !== "") reference = reference + "_";

        let currDate = new Date();
        let formattedDate;
        if (PublicVariables.featureFlag?.ENABLEFOLDERNAMING === ENABLED && PublicVariables.featureFlag?.FILENAMEFORMAT !== "") {
            let utcDate = moment.utc(currDate, "YYYY-MM-DD-hh-mm-ss-A");
            formattedDate = utcDate.format("YYYY-MM-DD-hh-mm-ss-A");
            let tempFileName = PublicVariables.featureFlag?.FILENAMEFORMAT;
            tempFileName = tempFileName.replace("_{bookmark}", "");
            fileName = tempFileName + "_" + formattedDate + "_" + type;
        } else {
            let utcDate = moment.utc(currDate, "YYYY_MM_DD_hh_mm_ss_A");
            formattedDate = utcDate.format("YYYY_MM_DD_hh_mm_ss_A");
            fileName = cleanAgentName + "_" + reference + formattedDate + "_" + type;
        }
        if (type == "location") {
            fileName = fileName + "." + extension;
        } else {
            let suffix =
                PublicVariables.featureFlag?.ENABLEFOLDERNAMING === ENABLED && PublicVariables.featureFlag?.FILENAMEFORMAT !== "" ? "-" : "_";
            fileName = fileName + suffix + totalPhotos + "." + extension;
        }
        return fileName;
    }
}
export default new TakePhotoService();
